// The close: what planning does next.
//
// Jake's rule for the last page (2026-09-29): "we never talk about selling a
// financial plan. It's always that you're hiring us for planning", so the
// page describes the process, not a product. Eugene's: it has to make the
// case that there is value on the other side of that decision. His deck's
// "cost of waiting" slide made that case, but it implied the figures go away
// once planning starts, and fees and protection gaps do not (Jimmy and John,
// 2026-10-01). So the page opens with this household's figures as what
// planning would work on, each only when it is actually known. Then the
// questions the assessment has raised and cannot answer, and the six areas
// planning works through, which are the six the meeting opened with. The
// meeting ends on the advisor's own question, not on a printed one.

const PLANNING = [
  { key: 'cash', n: '01', title: 'Cash flow planning', line: 'Your income, spending and savings, now and in every year of retirement, lined up with what you want.' },
  { key: 'tax', n: '02', title: 'Tax planning', line: 'A strategy that builds tax diversification and keeps future tax down, including whether and how much to convert to Roth.' },
  { key: 'investments', n: '03', title: 'Investment strategy', line: 'A diversified, goals-based portfolio, with each investment held where it is taxed least.' },
  { key: 'risk', n: '04', title: 'Insurance and risk review', line: 'Long-term care, life, umbrella, home, auto and health, so one bad year cannot undo the good ones.' },
  { key: 'estate', n: '05', title: 'Estate plan review', line: 'The documents and titling that get your estate where you intend it, without the court and without the fees.' },
  { key: 'coordination', n: '06', title: 'Coordination', line: 'Your accountant, attorney and advisor working together instead of separately.' },
];

export default function NextSteps({ workingOn = [], questions = [] }) {
  const asked = questions.slice(0, 4);
  return (
    <>
      <div className="conv-eyebrow">What planning does next</div>
      <h1>What we would work out together</h1>
      <p className="conv-lede">
        Everything so far is what can be read from your questionnaire and your statements. Planning is where the
        questions it raises get answered, with you.
      </p>

      {workingOn.length ? (
        <div className="conv-wait">
          <span className="conv-eyebrow">What planning would work on</span>
          <div className="conv-wait-tiles">
            {workingOn.map(c => (
              <div key={c.key}>
                <strong>{c.value}</strong>
                <span>{c.label}</span>
              </div>
            ))}
          </div>
        </div>
      ) : null}

      <div className="conv-next-grid">
        {asked.length ? (
          <section className="conv-questions">
            <span className="conv-eyebrow">The questions in front of you</span>
            <ol>
              {asked.map((q, i) => (
                <li key={q.key}>
                  <span className="conv-n">{String(i + 1).padStart(2, '0')}</span>
                  <div>
                    <strong>{q.question}</strong>
                    <p>{q.because}</p>
                  </div>
                </li>
              ))}
            </ol>
          </section>
        ) : null}
        <section className="conv-covers">
          <span className="conv-eyebrow">What planning works through</span>
          <ol>
            {PLANNING.map(p => (
              <li key={p.key}>
                <span className="conv-n">{p.n}</span>
                <div>
                  <strong>{p.title}</strong>
                  <span>{p.line}</span>
                </div>
              </li>
            ))}
          </ol>
        </section>
      </div>

    </>
  );
}
